var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-backgroundbackground"},[_c('div',{staticClass:"video-background",style:({'background-color': _vm.backgroundColor })}),_vm._v(" "),_c('div',{ref:"darkener",staticClass:"darken"})])
}
var staticRenderFns = []

export { render, staticRenderFns }